var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header"),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-2 pt-5 pl-5 pr-5 pb-2",
              attrs: { cols: "12" },
            },
            [
              _vm.tokenExisted
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 mb-5",
                      attrs: { cols: "12", align: "start" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            loading: _vm.streamingUrlLoading,
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.goVideoTest },
                        },
                        [_vm._v(" " + _vm._s("Video Test Page") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.goWebRTCVideo },
                        },
                        [_vm._v(" " + _vm._s("KVSWebRTC Video Test") + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mb-5", attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "1" } },
                        [_vm._v(_vm._s("video.js - "))]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goMultiVideoTest(4, "video")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s("4 Video Viewer") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goMultiVideoTest(9, "video")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s("9 Video Viewer") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goMultiVideoTest(16, "video")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s("16 Video Viewer") + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mb-5", attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "1" } },
                        [_vm._v(_vm._s("hls.js - "))]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goMultiVideoTest(4, "hls")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s("4 Video Viewer") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goMultiVideoTest(9, "hls")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s("9 Video Viewer") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goMultiVideoTest(16, "hls")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s("16 Video Viewer") + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.tokenExisted
                ? _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0 mb-5", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-2 text-none",
                              attrs: {
                                width: "auto",
                                height: "auto",
                                id: "grey_btn",
                                elevation: "0",
                              },
                              on: { click: _vm.goVideoThumbnailTest },
                            },
                            [_vm._v(" " + _vm._s("Video Thumbnail") + " ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-2 ml-4",
                              attrs: {
                                width: "auto",
                                height: "auto",
                                id: "grey_btn",
                                elevation: "0",
                              },
                              on: { click: _vm.goAllStoreAnalyticsTest },
                            },
                            [_vm._v(" " + _vm._s("전점포 페이지") + " ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-2 ml-4",
                              attrs: {
                                width: "auto",
                                height: "auto",
                                id: "grey_btn",
                                elevation: "0",
                                loading: _vm.streamingUrlLoading,
                              },
                              on: { click: _vm.goFabricTest },
                            },
                            [_vm._v(" " + _vm._s("Fabric Test") + " ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-2 ml-4 text-none",
                              attrs: {
                                width: "auto",
                                height: "auth",
                                id: "grey_btn",
                                elevation: "0",
                              },
                              on: { click: _vm.goWebRTCTest },
                            },
                            [_vm._v(" " + _vm._s("WebRTC Module") + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider", {
                staticClass: "ma-0 pa-0 mb-5",
                attrs: { id: "middle_divider" },
              }),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mb-5", attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              _vm.snackbar = true
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s("기본 Snackbar") + " ")]
                      ),
                      _c(
                        "v-snackbar",
                        {
                          attrs: { dark: "", centered: "", timeout: 2000 },
                          model: {
                            value: _vm.snackbar,
                            callback: function ($$v) {
                              _vm.snackbar = $$v
                            },
                            expression: "snackbar",
                          },
                        },
                        [_vm._v(" " + _vm._s("Snackbar Test") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.testToast },
                        },
                        [_vm._v(" " + _vm._s("Custom Toast Test") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.testConfirmDialog },
                        },
                        [_vm._v(" " + _vm._s("Comfirm Dialog") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.testInfoDialog },
                        },
                        [_vm._v(" " + _vm._s("Info Dialog") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-2 ml-4 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "grey_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.testOverlayLoading },
                        },
                        [_vm._v(" " + _vm._s("Overlay Loading Test") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0 text-none",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "back_clean_btn",
                            elevation: "0",
                          },
                        },
                        [
                          _c("v-img", {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              "max-height": "2rem",
                              "max-width": "2rem",
                              src: require("@/assets/images/calendar.png"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mb-5", attrs: { cols: "12" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { cols: "12", align: "left" },
                    },
                    [_vm._v(_vm._s("Loader Test"))]
                  ),
                  _c("ImageSkeleton", {
                    attrs: { loaderCount: 3, width: "100%", height: "9rem" },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mb-5", attrs: { cols: "4" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "start" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { cols: "3" },
                          on: {
                            click: function ($event) {
                              return _vm.openTimePicker("begin")
                            },
                          },
                        },
                        [
                          _c("v-text-field", {
                            staticStyle: { "font-size": "0.7rem" },
                            attrs: {
                              dark: "",
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                              "append-icon": "mdi-menu-down",
                              readonly: "",
                              "background-color": "#272727",
                            },
                            model: {
                              value: _vm.beginTimeValue,
                              callback: function ($$v) {
                                _vm.beginTimeValue = $$v
                              },
                              expression: "beginTimeValue",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-1 pr-1",
                          attrs: { cols: "1", align: "center" },
                        },
                        [_vm._v(_vm._s("~"))]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { cols: "3" },
                          on: {
                            click: function ($event) {
                              return _vm.openTimePicker("end")
                            },
                          },
                        },
                        [
                          _c("v-text-field", {
                            staticStyle: { "font-size": "0.7rem" },
                            attrs: {
                              dark: "",
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                              "append-icon": "mdi-menu-down",
                              readonly: "",
                              "background-color": "#272727",
                            },
                            model: {
                              value: _vm.endTimeValue,
                              callback: function ($$v) {
                                _vm.endTimeValue = $$v
                              },
                              expression: "endTimeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("TimePicker", {
        attrs: { dialogVisible: _vm.timePickerDialogVisible },
        on: {
          visible: _vm.timePickerDialogVisibleFunc,
          timeValue: _vm.timeValueFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }